export const isSuperIntersectionObserver = () => 'IntersectionObserver' in window;

export const isSuperResizeObserver = () => 'ResizeObserver' in window;

export const affixStatus = {
  none: 1,
  fixed: 2,
};

export const getRect = (el) => {
  if (!el) return {};
  if (el === window) {
    return {
      top: 0,
      bottom: window.innerHeight,
    };
  }

  return el.getBoundingClientRect();
};
